module.exports = __webpack_public_path__ + "img/BatteryLow.13f92c0f.svg";